import WarningAlertIcon from '../../../../../../images/warning_alert_outline_yellow.svg';
import ConfirmationCheckIcon from '../../../../../../images/confirmation-check.svg';
import { Colors } from '../../../../../../themes/colors';
import CustomPortal from '../../../../../commonComponents/CustomPortal';
import { CandidateStatus } from '../../../../../../domain/PermanentJobs';

const POPUP_CONFIG = {
  [CandidateStatus.APPLIED]: {
    confirm: {
      title: 'Restore Candidate',
      getMessage: (name) => (
        <>
          You’re about to restore <strong>{name}’s</strong> status back to <strong>Applied</strong>.
          Are you sure you want to continue?
        </>
      ),
      leftButton: 'Go Back',
      rightButton: 'Confirm',
    },
    success: {
      icon: ConfirmationCheckIcon,
      title: 'Candidate Restored',
      getMessage: (name) =>
        `${name}'s application has been restored and their status is now Applied.`,
      button: 'Done',
    },
  },
  [CandidateStatus.INTERVIEWED]: {
    confirm: {
      title: 'Restore Candidate',
      getMessage: (name) => (
        <>
          You’re about to restore <strong>{name}’s</strong> status back to{' '}
          <strong>Interviewed</strong>. Are you sure you want to continue?
        </>
      ),
      leftButton: 'Go Back',
      rightButton: 'Confirm',
    },
    success: {
      icon: ConfirmationCheckIcon,
      title: 'Candidate Restored',
      getMessage: (name) =>
        `${name}'s application has been restored and their status is now Interviewed.`,
      button: 'Done',
    },
  },
  [CandidateStatus.EXPIRED]: {
    confirm: {
      title: 'Restore Candidate',
      getMessage: (name) => (
        <>
          You’re about to restore <strong>{name}’s</strong> status back to{' '}
          <strong>Expired</strong>. Are you sure you want to continue?
        </>
      ),
      leftButton: 'Go Back',
      rightButton: 'Confirm',
    },
    success: {
      icon: ConfirmationCheckIcon,
      title: 'Candidate Restored',
      getMessage: (name) =>
        `${name}'s application has been restored and their status is now Expired.`,
      button: 'Done',
    },
  },
  [CandidateStatus.REJECTED]: {
    confirm: {
      icon: WarningAlertIcon,
      title: 'Before You Continue',
      getMessage: (name) => (
        <>
          This action is permanent. Once rejected, <strong>{name}</strong> will no longer be able to
          apply to onsite interviews for this job. Do you want to continue?
        </>
      ),
      leftButton: 'Go Back',
      rightButton: 'Yes, Reject',
    },
    success: {
      icon: ConfirmationCheckIcon,
      title: 'Candidate Rejected',
      getMessage: (name) => `${name}'s application is no longer active and they are now Rejected.`,
      button: 'Done',
    },
  },
  [CandidateStatus.HIRED]: {
    confirm: {
      title: 'Mark Candidate as Hired',
      getMessage: (name) => (
        <>
          You’re about to mark <strong>{name}</strong> as Hired for this position. A confirmation
          message will be sent to the candidate. This job will remain open for additional applicants
          until its status is set to Closed.
        </>
      ),
      leftButton: 'Go Back',
      rightButton: 'Confirm',
    },
    success: {
      icon: ConfirmationCheckIcon,
      title: 'Candidate Hired',
      getMessage: () =>
        // eslint-disable-next-line max-len
        `The candidate's status has been updated to hired. This job will remain open until closed by an admin or the office.`,
      button: 'Done',
    },
  },
};

export const CandidateActionPopup = ({
  status,
  candidateName,
  state,
  isLoading = false,
  onCancel,
  onConfirm,
  onDone,
}) => {
  const config = POPUP_CONFIG[status]?.[state];

  if (!config) {
    return null;
  }

  if (state === 'confirm') {
    return (
      <CustomPortal
        Icon={config.icon}
        title={config.title}
        cancelText={config.leftButton}
        submitText={config.rightButton}
        containerStyle={{ paddingInline: 50, paddingTop: 30 }}
        textStyle={{ textAlign: 'center' }}
        rightButtonDisabled={isLoading}
        cancelPressed={onCancel}
        submitPressed={onConfirm}
      >
        <p style={{ color: Colors.neutral_500, fontSize: 16, textAlign: 'center' }}>
          {config.getMessage(candidateName)}
        </p>
      </CustomPortal>
    );
  }

  if (state === 'success') {
    return (
      <CustomPortal
        Icon={config.icon}
        title={config.title}
        submitText={config.button}
        containerStyle={{ paddingInline: 50, paddingTop: 30 }}
        textStyle={{ textAlign: 'center' }}
        hideLeftButton
        submitPressed={onDone}
      >
        <p style={{ color: Colors.neutral_500, fontSize: 16, textAlign: 'center' }}>
          {config.getMessage(candidateName)}
        </p>
      </CustomPortal>
    );
  }

  return null;
};
